import { render } from "./gestordocumentos_datosadicionales.vue?vue&type=template&id=312b8d9c&scoped=true"
import script from "./gestordocumentos_datosadicionales.vue?vue&type=script&lang=js"
export * from "./gestordocumentos_datosadicionales.vue?vue&type=script&lang=js"

import "./gestordocumentos_datosadicionales.vue?vue&type=style&index=0&id=312b8d9c&scoped=true&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-312b8d9c"]])

export default __exports__